<template>
  <div>
    <!-- Impersonate Banner (Only shown when impersonating a non-admin user) -->
    <div
      v-if="isImpersonating"
      class="impersonate-fixed-banner d-flex align-center justify-space-between px-4"
    >
      <div class="d-flex align-center text-truncate mr-2">
        <v-icon color="white" small class="mr-2">mdi-account-eye-outline</v-icon>
        <span class="impersonate-text">
          <strong>Chế độ Admin:</strong> Đang xem tài khoản
          <span class="user-badge ml-1">{{ currentUserName }}</span>
          <span class="caption ml-1 font-weight-medium opacity-85" v-if="currentUserHandle">({{ currentUserHandle }})</span>
        </span>
      </div>
      <div class="d-flex align-center">
        <v-btn
          x-small
          depressed
          class="revert-btn font-weight-bold"
          :loading="isReverting"
          @click="onRevert"
        >
          <v-icon left x-small>mdi-logout-variant</v-icon>
          Quay lại Admin
        </v-btn>
      </div>
    </div>

    <!-- Original standard Vuetify system bar: always 50px -->
    <v-system-bar app color="white" flat height="50px" class="app-bar">
      <router-link :to="{ name: 'home' }" exact style="text-decoration: none">
        <a class="navbar-brand logo"><span class="mr-1">Pro</span>Editor</a>
      </router-link>
      <v-tabs right color="grey darken-1" :key="keyTabBar">
        <v-tab v-if="userData" @click="onClickServerRender">
          <v-icon size="20">mdi-bell-ring</v-icon>
        </v-tab>
        <v-tab class="hover-header-title" v-for="link in listHeaderTitle" :key="link.text" :to="link.path">
          <v-icon class="hidden-sm-and-up" style="font-size: 24px" v-text="link.icon"></v-icon>
          <span class="hidden-xs-and-down " v-if="$vuetify.breakpoint.smAndUp">{{ link.text }}</span>
        </v-tab>
      </v-tabs>
            <v-btn
        v-if="isAdmin"
        icon
        class="mx-1"
        color="amber darken-3"
        title="Chuyển nhanh sang tài khoản User"
        @click="openQuickSwitchDialog"
      >
        <v-icon size="22">mdi-account-switch</v-icon>
      </v-btn>
      <v-menu
        v-if="$store.state.isUserLoggedIn && userData"
        v-model="userMenu"
        offset-y
        left
        nudge-bottom="6"
        transition="slide-y-transition"
        min-width="260"
        rounded="lg"
        content-class="user-dropdown-menu elevation-6"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" class="mx-1 user-avatar-btn">
            <v-avatar v-if="userData && userData.avatar" size="34" class="user-avatar-bordered">
              <img class="avatar" :src="userData.avatar" alt="Avatar" />
            </v-avatar>
            <v-avatar v-else color="rgb(0, 152, 253)" size="34" class="user-avatar-bordered">
              <span class="white--text font-weight-bold" style="font-size: 15px">
                {{ userData.name ? userData.name.charAt(0).toUpperCase() : 'U' }}
              </span>
            </v-avatar>
          </v-btn>
        </template>

        <v-card class="user-dropdown-card">
          <!-- User Info Header -->
          <div class="user-header-box pa-3 d-flex align-center" @click="openAccountModal" style="cursor: pointer" title="Xem thông tin tài khoản">
            <v-avatar size="42" class="mr-3" color="rgb(0, 152, 253)">
              <img v-if="userData.avatar" :src="userData.avatar" alt="Avatar" class="avatar" />
              <span v-else class="white--text font-weight-bold text-h6">
                {{ userData.name ? userData.name.charAt(0).toUpperCase() : 'U' }}
              </span>
            </v-avatar>
            <div class="user-meta-info" style="min-width: 0; flex: 1">
              <div class="font-weight-bold text-subtitle-2 text-truncate text-capitalize" :title="userData.name">
                {{ userData.name || userData.username }}
              </div>
              <div class="caption grey--text text-truncate" :title="userData.email || userData.username">
                {{ userData.email || userData.username }}
              </div>
              <div class="caption primary--text font-weight-bold mt-1">
                Số dư: {{ formatBalance(userData.balance) }}
              </div>
            </div>
          </div>

          <v-divider class="my-0"></v-divider>

          <!-- Navigation Links -->
          <v-list dense nav class="py-1">
            <v-list-item @click="openAccountModal" link>
              <v-list-item-icon class="mr-3 my-2">
                <v-icon size="20" color="primary">mdi-account-circle-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="font-weight-medium">Tài khoản</v-list-item-title>
            </v-list-item>

            <v-list-item @click="openSettingsModal" link>
              <v-list-item-icon class="mr-3 my-2">
                <v-icon size="20" color="blue-grey">mdi-cog-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="font-weight-medium">Cài đặt</v-list-item-title>
            </v-list-item>

                        <v-list-item v-if="isAdmin" @click="openQuickSwitchDialog" link>
              <v-list-item-icon class="mr-3 my-2">
                <v-icon size="20" color="amber darken-3">mdi-account-switch</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="font-weight-medium">Đổi tài khoản User</v-list-item-title>
            </v-list-item>
            <v-list-item v-if="isAdmin" to="/admin" link>
              <v-list-item-icon class="mr-3 my-2">
                <v-icon size="20" color="amber darken-2">mdi-shield-crown-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="font-weight-bold amber--text text--darken-3">Admin Dashboard</v-list-item-title>
            </v-list-item>

            <v-list-item v-if="isImpersonating" @click="onRevert" link class="amber lighten-5">
              <v-list-item-icon class="mr-3 my-2">
                <v-icon size="20" color="amber darken-3">mdi-logout-variant</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="font-weight-bold amber--text text--darken-4">Quay lại Admin</v-list-item-title>
            </v-list-item>

            <v-divider class="my-1"></v-divider>

            <v-list-item @click="signout" link class="logout-item">
              <v-list-item-icon class="mr-3 my-2">
                <v-icon size="20" color="error">mdi-logout-variant</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="error--text font-weight-bold">Đăng xuất</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-system-bar>
    <v-navigation-drawer width="560" style="max-width: 100vw" v-model="isShowInfoServer" absolute bottom temporary right class="px-2">
      <div class="text-center my-2 mb-3 mt-3" style="position: relative">
        <h3 class="font-weight-bold">Thông tin Server</h3>
      </div>
      <div>
        <h5>
          Số Video Đang Chờ Render:
          <span class="font-weight-bold text-primary mx-2" style="font-size: 25px">{{ listVideoQueuing.length }}</span>
          <v-icon v-if="isAdmin && !isShowVideoQueuing" @click="isShowVideoQueuing = true"
            class="icon-show-detail mx-2">mdi-chevron-down-circle</v-icon>
          <v-icon v-else-if="isAdmin" @click="isShowVideoQueuing = false" class="icon-hide-detail mx-2">
            mdi-chevron-up-circle
          </v-icon>
        </h5>
        <table v-if="isAdmin && isShowVideoQueuing && listVideoQueuing"
          class="table table-hover table-bordered table-sm text-center">
          <thead>
            <th>ID Video</th>
            <th>Tên tài khoản</th>
          </thead>
          <tr v-for="(video, i) in listVideoQueuing" :key="i">
            <td>
              {{ video._id }}
            </td>
            <td>
              {{ video.username }}
            </td>
          </tr>
        </table>
      </div>
      <div>
        <div v-for="(item, index) in listServer" :key="index" class="item-server">
          <h5 class="font-weight-bold ">
            <a :href="item.domain">{{ `${item.name} ` }} </a>
            <v-icon v-if="item && item.data" class="icon-live">
              mdi-heart
            </v-icon>
            <v-icon v-else class="icon-die">
              mdi-heart-outline
            </v-icon>
          </h5>
          <table>
            <tr>
              <td>Video đang render:</td>
              <td>
                <span class="font-weight-bold text-primary mx-2" style="font-size: 20px">
                  {{
                    item && item.data && item.data.listVideoRendering
                      ? item.data.listVideoRendering.length
                      : 0
                  }}
                </span>
              </td>
              <td>
                <v-icon v-if="isAdmin && !item.isShow" @click="listServer[index].isShow = true"
                  class="icon-show-detail mx-2">mdi-chevron-down-circle</v-icon>
                <v-icon v-else-if="isAdmin" @click="listServer[index].isShow = false" class="icon-hide-detail mx-2">
                  mdi-chevron-up-circle
                </v-icon>
              </td>
            </tr>
          </table>

          <table v-if="
            isAdmin && item && item.isShow && item.data && item.data.listVideoRendering
          " class="table table-hover table-bordered table-sm text-center">
            <thead>
              <th>Video</th>
              <th>Tài khoản</th>
              <th>Kênh</th>
              <th>Đã render</th>
            </thead>
            <tr v-for="(video, i) in item.data.listVideoRendering" :key="i">
              <td>
                <div class="font-weight-bold">{{ video.name || video._id }}</div>
                <div class="caption grey--text">ID: {{ video._id }}</div>
              </td>
              <td>
                {{ video.username }}
              </td>
              <td>
                {{ video.channelName || "—" }}
              </td>
              <td class="font-weight-bold text-primary">
                {{ renderElapsed(video) }}
              </td>
            </tr>
          </table>
        </div>
      </div>
      <loading :active.sync="isLoading" :is-full-page="false" :width="50" :height="50" />
    </v-navigation-drawer>

    <!-- Account Modal -->
    <v-dialog
      v-model="showAccountModal"
      max-width="1000"
      scrollable
      content-class="user-modal-dialog"
    >
      <v-card class="user-modal-card rounded-lg">
        <v-card-title class="user-modal-title py-3 px-4 d-flex align-center justify-space-between">
          <div class="d-flex align-center font-weight-bold text-subtitle-1">
            <v-icon color="primary" class="mr-2">mdi-account-circle</v-icon>
            <span>Thông tin tài khoản</span>
          </div>
          <v-btn icon small @click="showAccountModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="my-0"></v-divider>
        <v-card-text class="pa-4 pa-sm-6" style="max-height: 80vh">
          <AccountSetting v-if="showAccountModal" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Settings Modal -->
    <v-dialog
      v-model="showSettingsModal"
      max-width="720"
      scrollable
      content-class="user-modal-dialog"
    >
      <v-card class="user-modal-card rounded-lg">
        <v-card-title class="user-modal-title py-3 px-4 d-flex align-center justify-space-between">
          <div class="d-flex align-center font-weight-bold text-subtitle-1">
            <v-icon color="blue-grey" class="mr-2">mdi-cog</v-icon>
            <span>Cài đặt hệ thống</span>
          </div>
          <v-btn icon small @click="showSettingsModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider class="my-0"></v-divider>
        <v-card-text class="pa-4 pa-sm-6" style="max-height: 80vh">
          <Settings v-if="showSettingsModal" :is-modal="true" @saved="showSettingsModal = false" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <ModalQuickSwitchAccount v-if="isAdmin" ref="modalQuickSwitchAccount" />
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import ServiceApi from "../services/ServiceApi";
import ImpersonateService from "@/services/ImpersonateService";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      sidebar: false,
      keyTabBar: 0,
      isShowInfoServer: false,
      listServer: [],
      isLoading: false,
      listVideoQueuing: [],
      isShowVideoQueuing: false,
      serverInfoFetchedAt: 0,
      nowTick: Date.now(),
      infoTickTimer: null,
      infoRefreshTimer: null,
      userMenu: false,
      showAccountModal: false,
      showSettingsModal: false,
      isImpersonating: ImpersonateService.isImpersonating(),
      isReverting: false
    };
  },
  watch: {
    "$vuetify.breakpoint.name": {
      deep: true,
      handler() {
        this.keyTabBar++;
      }
    },
    isShowInfoServer(value) {
      if (!value) this.stopInfoTimers();
    },
    "$store.state.user"() {
      this.checkImpersonateStatus();
    },
    $route() {
      this.checkImpersonateStatus();
      this.userMenu = false;
      this.showAccountModal = false;
      this.showSettingsModal = false;
    }
  },
  components: {
    Loading,
    ModalQuickSwitchAccount: () => import("@/components/ModalQuickSwitchAccount.vue"),
    AccountSetting: () => import("@/screens/UserProfile/AccountSetting/index.vue"),
    Settings: () => import("@/screens/UserProfile/Settings/index.vue")
  },
  computed: {
    listHeaderTitle() {
      let menuItems = [
        {
          text: "Bảng Giá",
          show: this.$store.state.isUserLoggedIn,
          path: "/pricing",
          icon: "mdi-cash-multiple"
        },
        {
          text: "Bảng Giá",
          show: !this.$store.state.isUserLoggedIn,
          path: "/pricing",
          icon: "mdi-cash-multiple"
        },
        {
          text: "Đăng nhập",
          show: !this.$store.state.isUserLoggedIn,
          path: "/signin",
          icon: "mdi-login-variant"
        },
        {
          text: "Chức Năng",
          show: this.$store.state.isUserLoggedIn,
          path: "/workflow",
          icon: "mdi-atom"
        },
        {
          text: "Danh sách Video",
          show: this.$store.state.isUserLoggedIn,
          path: "/manager-video",
          icon: "mdi-clipboard-list-outline"
        },
      ];
      return menuItems.filter(item => item.show);
    },
    ...mapGetters(["userData"]),
        currentUserName() {
      return (this.userData && (this.userData.name || this.userData.username)) || "Người dùng";
    },
    currentUserHandle() {
      return (this.userData && this.userData.username) ? `@${this.userData.username}` : "";
    },
    isAdmin() {
      return Boolean(
        this.userData && (
          this.userData.username === "admin" ||
          this.userData.type === "admin" ||
          this.userData.email === "admin"
        )
      );
    }
  },
    created() {
      this.checkImpersonateStatus();
    },
    mounted() {
    this.checkImpersonateStatus();
    window.addEventListener("storage", this.checkImpersonateStatus);
  },
  beforeDestroy() {
    window.removeEventListener("storage", this.checkImpersonateStatus);
    this.stopInfoTimers();
    if (typeof document !== "undefined") {
      document.body.classList.remove("is-impersonating-active");
    }
  },
  methods: {
    formatBalance(val) {
      const num = Number(val) || 0;
      return new Intl.NumberFormat("vi-VN", { style: "currency", currency: "VND" }).format(num);
    },
    async onClickServerRender() {
      this.isLoading = true;
      let listVideoQueuing = [];
      let listServer = [];
      try {
        this.isShowInfoServer = true;
        let res = await ServiceApi.getInfoServer();
        if (res && res.status === 200) {
          listServer = res.data.listServer;
          listVideoQueuing = res.data.listVideoQueuing;
        }
      } catch (error) { }

      listServer = listServer.map(item => {
        return { ...item, isShow: false };
      });
      this.listVideoQueuing = listVideoQueuing;
      this.listServer = listServer;
      this.serverInfoFetchedAt = Date.now();
      this.nowTick = this.serverInfoFetchedAt;
      this.isLoading = false;
      this.startInfoTimers();
    },
    // Thời gian đã render = số giây máy render báo lúc lấy dữ liệu + thời gian trôi qua trên trình duyệt kể từ đó.
    renderElapsed(video) {
      if (!video || video.elapsedMs === null || video.elapsedMs === undefined) return "—";
      const totalSeconds = Math.floor((Number(video.elapsedMs) + Math.max(0, this.nowTick - this.serverInfoFetchedAt)) / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      const pad = (number) => String(number).padStart(2, "0");
      return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    },
    startInfoTimers() {
      this.stopInfoTimers();
      this.infoTickTimer = setInterval(() => { this.nowTick = Date.now(); }, 1000);
      // Làm mới ngầm khi bảng đang mở để thấy video mới/đã xong mà không phải mở lại.
      this.infoRefreshTimer = setInterval(() => this.refreshServerInfo(), 15000);
    },
    stopInfoTimers() {
      if (this.infoTickTimer) clearInterval(this.infoTickTimer);
      if (this.infoRefreshTimer) clearInterval(this.infoRefreshTimer);
      this.infoTickTimer = null;
      this.infoRefreshTimer = null;
    },
    async refreshServerInfo() {
      if (!this.isShowInfoServer) return;
      try {
        const res = await ServiceApi.getInfoServer();
        if (!res || res.status !== 200) return;
        const expanded = new Set(this.listServer.filter(item => item.isShow).map(item => item._id || item.name));
        this.listServer = (res.data.listServer || []).map(item => ({ ...item, isShow: expanded.has(item._id || item.name) }));
        this.listVideoQueuing = res.data.listVideoQueuing || [];
        this.serverInfoFetchedAt = Date.now();
        this.nowTick = this.serverInfoFetchedAt;
      } catch (error) { }
    },
    openQuickSwitchDialog() {
      this.userMenu = false;
      this.$nextTick(() => {
        if (this.$refs.modalQuickSwitchAccount) {
          this.$refs.modalQuickSwitchAccount.open();
        }
      });
    },
    openAccountModal() {
      this.userMenu = false;
      this.showAccountModal = true;
    },
    openSettingsModal() {
      this.userMenu = false;
      this.showSettingsModal = true;
    },
    checkImpersonateStatus() {
      // Backup is only removed by revert/signout, never implicitly here.
      this.isImpersonating = Boolean(this.userData) && !this.isAdmin && ImpersonateService.isImpersonating();
      if (typeof document !== "undefined") {
        if (this.isImpersonating) {
          document.body.classList.add("is-impersonating-active");
        } else {
          document.body.classList.remove("is-impersonating-active");
        }
      }
    },
    async onRevert() {
      if (this.isReverting) return;
      this.isReverting = true;
      try {
        await ImpersonateService.revertImpersonate(this.$store);
        this.isImpersonating = false;
        // Stay on the current page; reload so page data is refetched as Admin.
        location.reload();
      } catch (err) {
        this.isReverting = false;
        this.$swal.fire("Lỗi", err.message || "Không thể quay lại Admin", "error");
      }
    },
    signout() {
      localStorage.removeItem("admin_impersonate_backup");
      this.isImpersonating = false;
      this.$store.dispatch("setUser", null);
      this.$router.push("/signin");
      this.$swal.fire({
        icon: "success",
        title: "Logout successful",
        showConfirmButton: false,
        timer: 1000
      });
    }
  }
};
</script>

<style scoped>
.impersonate-fixed-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 36px;
  min-height: 36px;
  background: linear-gradient(90deg, #e65100 0%, #f57c00 100%);
  color: #ffffff;
  font-size: 13px;
  box-sizing: border-box;
  z-index: 99999 !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

.impersonate-text {
  font-size: 13px;
  line-height: 1.4;
}

.user-badge {
  background: rgba(255, 255, 255, 0.22);
  padding: 1px 7px;
  border-radius: 5px;
  font-weight: 700;
}

.revert-btn {
  background-color: #ffffff !important;
  color: #d84315 !important;
  border-radius: 5px;
  text-transform: none;
  font-size: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15) !important;
}
.revert-btn:hover {
  background-color: #fff3e0 !important;
}
.opacity-85 {
  opacity: 0.85;
}

.app-bar {
  box-shadow: 0px 1px 4px 1px #d9d9d9;
  z-index: 7 !important;
}

.user-dropdown-card {
  border-radius: 10px;
  overflow: hidden;
}

.user-modal-card {
  overflow: hidden;
  background: #ffffff;
}

.user-modal-title {
  background: #f8f9fa !important;
}

.user-header-box {
  background: linear-gradient(135deg, #f8faff 0%, #f0f4f9 100%);
}

.user-avatar-btn:hover {
  transform: scale(1.05);
  transition: transform 0.2s ease;
}

.user-avatar-bordered {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.avatar {
  -webkit-transition: all 0.3s ease-out 0s;
  -moz-transition: all 0.3s ease-out 0s;
  -ms-transition: all 0.3s ease-out 0s;
  -o-transition: all 0.3s ease-out 0s;
  object-fit: cover;
  width: 32px;
  height: 32px;
}

.navbar-brand.logo {
  font-size: 18px;
  font-weight: bold;
  text-decoration: none;
}

.navbar-brand.logo span {
  color: #ff5c97;
  border: 3px solid #ff5c97;
  border-radius: 6px;
  padding: 0px 5px;
}

.hover-header-title:hover {
  font-weight: bold !important;
  color: #000 !important;
}

.icon-show-detail {
  font-size: 23px !important;
  color: #04d435 !important;
}

.icon-live {
  color: red !important;
  padding: 5px !important;
}

.icon-die {
  color: #000 !important;
  padding: 5px !important;
}

.item-server {
  border: 1px solid #333 !important;
  padding: 5px !important;
  margin: 10px 0 10px 0 !important;
}

.icon-hide-detail {
  font-size: 23px !important;
  color: #555 !important;
}
</style>

<style>
body.is-impersonating-active .app-bar {
  top: 36px !important;
}
body.is-impersonating-active .v-navigation-drawer--fixed,
body.is-impersonating-active .v-navigation-drawer--app,
body.is-impersonating-active .v-navigation-drawer {
  top: 86px !important;
  height: calc(100% - 86px) !important;
}
body.is-impersonating-active .v-main {
  padding-top: 86px !important;
}
</style>



// WEBPACK FOOTER //
// src/layouts/Header.vue